import { Trans } from '@lingui/react/macro';

import { ArticleWithRelations } from '@/models/request';

import { BaseMessage } from './BaseMessage';

export const ValidateTransitTaskMessage = ({ article }: { article: ArticleWithRelations }) => {
  const destinationName = article.toEntity?.name;

  return (
    <BaseMessage
      article={article}
      title={<Trans id="article.task.validate-transit.title">Validate the transit</Trans>}
      message={
        <p>
          {destinationName ? (
            <Trans id="article.task.validate-transit.text.to-entity">
              Hand the item over to {destinationName} yourself or arrange for it to be picked up,
              then validate the transit.
            </Trans>
          ) : (
            <Trans id="article.task.validate-transit.text">
              Hand the item over yourself or arrange for it to be picked up, then validate the
              transit.
            </Trans>
          )}
        </p>
      }
    />
  );
};
